import FteModeToggle from "./FteModeToggle";

const FteDataSidebarContent = () => <FteModeToggle />;

export default FteDataSidebarContent;
